import {Font, Theme} from '@oneamerica/dxp-ui-components';
import ColorConstants from '../../constants/ColorConstants';

const styles = () =>
  Theme.Responsive.create({
    faFilePdfIcon: {
      width: 16,
      height: 16,
    },
    headerSection: {
      marginBottom: 24,
    },
    headerTextCell: {
      textAlign: 'left',
      fontWeight: Font.bold.fontWeight,
      fontFamily: Font.bold.fontFamily,
      flexWrap: 'wrap',
      flexShrink: 1,
      paddingVertical: 6,
      minHeight: 48,
      lineHeight: 18,
      includeFontPadding: false, 
      overflow: 'hidden',
    },        
    distributionCodeText: {
      textAlign: 'left',
      flexWrap: 'wrap',
    },    
    taxDocumentsTitle: {
      fontSize: 20,
      fontWeight: Font.bold.fontWeight,
      color: ColorConstants.blackText,
      fontFamily: Font.bold.fontFamily,
      marginBottom: 16,
    },
    // Table layout styles
    tablesContainer: {
      width: '100%',
      marginTop: 16,
    },
    desktopTablesRow: {
      flexDirection: 'row' as const,
      gap: 12,
      alignItems: 'flex-start' as const,
      width: '100%',
      flexWrap: 'wrap' as const, // Allow wrapping to next row
    },
    tabletTablesRow: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      gap: 16,
      minWidth: 675
    },
    mobileTablesColumn: {
      flexDirection: 'column' as const,
      gap: 6,
      width: '100%',
    },
    tableWrapper: {
      // flex: '1 1 calc(50% - 12px)' as any, // Each table takes roughly 50% width minus half the gap
      minWidth: 480,
      maxWidth: 'calc(50% - 12px)' as any,
      textAlign: 'center',
    },
    tabletTableWrapper: {
      flex: 1,
      minWidth: '48%',
      maxWidth: '48%',
      marginBottom: 16,
    },
    mobileTableWrapper: {
      width: '100%',
      minWidth: 320, // Ensure it doesn't exceed container width
      marginLeft: 0,
    },    
    accountTitle: {
      fontSize: 16,
      fontWeight: Font.bold.fontWeight,
      color: ColorConstants.blackText,
      marginBottom: 12,
      fontFamily: Font.bold.fontFamily,
    },
    mobileAccountTitle: {
      fontSize: 14, // Smaller font size for mobile
      fontWeight: Font.bold.fontWeight,
      color: ColorConstants.blackText,
      marginBottom: 8, // Reduced margin for mobile
      fontFamily: Font.bold.fontFamily,
    },
    // Custom OATable styling
    tableStyle: {
      backgroundColor: '#ffff',
      overflow: 'hidden' as const,
      borderWidth: 1,
      borderColor: 'rgba(92, 92, 92,0.2)',
    },
    tabletTableStyle : {
      fontSize:14,
    },
    mobileTableStyle: {
      backgroundColor: '#ffff',
      overflow: 'hidden' as const,
      borderWidth: 1,
      borderColor: 'rgba(92, 92, 92,0.2)',
      maxWidth: '100%', // Prevent overflow
    },
  })();

export default styles;
